<template>
  <div id="container404">
    <img :src="logo" alt="Logo Solutions +" class="logo-solution-plus" />
    <div id="colorover">
      <h1 class="ml14">
        <span class="text-wrapper">
          <span class="letters">OptiFlux 404</span>
          <span class="line"></span>
        </span>
      </h1>
      <h1 class="ml14">
        <span class="redirection smaller-text"
          >Votre page n'a pas pu être trouvée...</span
        >
      </h1>
      <h1 class="ml14">
        <router-link :to="{ path: '/vision-globale' }">
          <span class="redirection">Retour à la vision globale</span>
        </router-link>
      </h1>
      <div class="footer-mentions" v-if="showMentions">
        <v-icon aria-hidden="true" @click="closeMentions()" medium
          >close</v-icon
        >
        <p class="mentions-text">
          Application sécurisée - Solutions +
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import anime from 'animejs';
import JQuery from 'jquery';
let $ = JQuery;

export default {
  data() {
    return {
      logo: require('@/assets/images/LCA_SERVICES_SOLUTIONS.png'),
      showMentions: true,
    };
  },
  methods: {
    closeMentions() {
      this.showMentions = false;
    },
  },
  mounted() {
    if (this.$store.state.user.length === 0) {
      router.go();
      router.push('/');
    }
    $('.ml14 .letters').each(function() {
      $(this).html(
        $(this)
          .text()
          /* eslint-disable-next-line no-control-regex */
          .replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>")
      );
    });
    anime
      .timeline({ loop: false })
      .add({
        targets: '.ml14 .line',
        scaleX: [0, 1],
        opacity: [0.5, 1],
        easing: 'easeInOutExpo',
        duration: 1500,
      })
      .add({
        targets: '.ml14 .letter',
        opacity: [0, 1],
        translateX: [40, 0],
        translateZ: 0,
        scaleX: [0.3, 1],
        easing: 'easeOutExpo',
        duration: 500,
        offset: '-=400',
        delay: function(el, i) {
          return 150 + 25 * i;
        },
      });
  },
};
</script>

<style lang="scss" scoped>
.ml14 {
  font-weight: 200;
  font-size: 3.2em;
  margin-left: 20%;
  margin-top: 10vh;
}
.ml14 .text-wrapper {
  position: relative;
  display: inline-block;
  padding-top: 0.1em;
  padding-right: 0.05em;
  padding-bottom: 0.15em;
}
.ml14 .line {
  opacity: 0;
  position: absolute;
  left: 0;
  height: 57px;
  width: 300px;
  background-color: #ff9300;
  transform-origin: 100% 100%;
  bottom: -16px;
  z-index: 1;
}
.ml14 .letters {
  display: inline-block;
  line-height: 1em;
  position: absolute;
  z-index: 2;
  color: white;
  top: -23px;
  left: 7px;
  width: 300px;
}
>>> .v-messages__message {
  color: white;
  font-size: 1rem;
  background-color: #f8a331;
  padding: 3px 5px;
  width: fit-content;
}
.footer-mentions {
  position: absolute;
  color: rgb(65, 65, 65);
  bottom: 0;
  height: 48px;
  left: 0px;
  letter-spacing: 0.02rem;
  font-size: 1.1rem;
  background-color: white;
  width: 100vw;
  display: flex;
  .v-icon {
    color: #ff9400;
    line-height: 48px;
    padding: 0 10px;
  }
  .mentions-text {
    line-height: 48px;
  }
}
.fa-times-thin:before {
  content: '\00d7';
}
.fa-times-thin {
  color: #ff9400;
  margin: 0 10px 0 11px;
}
.logo-solution-plus {
  left: 10px;
  top: 10px;
  height: 130px;
  position: absolute;
}
#container404 {
  position: absolute;
  height: 100vh;
  width: 100vw;
  background-image: url('https://res.cloudinary.com/arteventmore/image/upload/v1543077380/bg_svj7q0.jpg');
  background-size: cover;
}
a {
  text-decoration: none !important;
}
.redirection {
  color: white;
  background: #ff9300;
  padding: 0 10px;
}
.smaller-text {
  font-size: 70%;
  padding: 5px;
}
</style>
